import React from "react";
import { Form } from "semantic-ui-react";
import useSelfExclusionForm from "../../hooks/useSelfExclusionForm";
import { getCurrentDateTime } from "../../helpers/datetime";

import DateAndTimeGroup from "@common/components/shared/forms/DateAndTimeGroup";
import FormButtonsComponent from "@common/components/shared/forms/FormButtonsComponent";
import SelectComponent from "@common/components/shared/forms/SelectComponent";
import InputComponent from "@common/components/shared/forms/InputComponent";
import StandardHiddenInputs from "@common/components/shared/forms/StandardHiddenInputs";

const SelfExclusionForm = () => {
  const { methods, onSubmit, onReset } = useSelfExclusionForm();
  const {
    watch,
    handleSubmit,
    register,
    control,
    formState: { errors, isValid },
  } = methods;

  return (
    <Form className="form-padding" onSubmit={handleSubmit(onSubmit)}>
      <StandardHiddenInputs />
      <DateAndTimeGroup
        control={control}
        dateFormat="YYYY-MM-DD"
        errorsTime={errors.time}
        maxDate={getCurrentDateTime()}
      />
      <SelectComponent
        name="selfExclusionType.id"
        label="Self-exclusion Event"
        placeholder="Select self-exclusion event"
        control={control}
        error={errors.selfExclusionType?.id}
        options={watch("selfExclusionTypes") ?? []}
        labelStyle="w-40"
      />
      <InputComponent
        name="customerReference"
        label="Customer SE Reference"
        placeholder="Please enter a reference"
        register={register}
        error={errors.customerReference}
        labelClass="w-40"
      />
      <FormButtonsComponent isValid={isValid} resetForm={onReset} />
    </Form>
  );
};

export default SelfExclusionForm;
